module.exports = function getResource(label) {
    let resources = {
        makeup: 'makeup',
        skincare: 'skincare',
        hair: 'hair',
        fragrance: 'fragrance',
        gifts: 'gifts'
    };

    return resources[label];
};
